// import index from '@views/agency/index'; //经销商主页
// import agencyLogin from '@views/agency/login'; //经销商主页
// import recordList from '@views/agency/recordList'; //全局备案查询列表
// import myRecordList from '@views/agency/myRecordList'; //我的备案列表
// import projectRecordForm from '@views/agency/projectRecordForm'; //工程备案申请表
// import cashDepositForm from '@views/agency/cashDepositForm'; //退备案保证金
// import protectionRecordForm from '@views/agency/protectionRecordForm'; //保护区备案登记表
// import againRecordForm from '@views/agency/againRecordForm'; //工程备案续备案
// import newComPage from '@views/agency/newComPage'; //公示公告、新品发布、管理制度
// import newComContent from '@views/agency/newComContent'; //公示公告、新品发布、管理制度相关详情
// import legalPersonAuth from '@views/agency/legalPersonAuth'; //法人授权
// import legalPersonAuthForm from '@views/agency/legalPersonAuthForm';
// import myJob from '@views/agency/myJob';
// import specialStore from '@views/agency/specialStore';//专卖店首页
const agencyRouter = [
  {
    path: "index",
    name: "index",
    // component: index,
    component: (resolve) => require(["@views/agency/index"], resolve),
    meta: {
      title: "经销商专区",
      requireAuth: false,
    },
  },
  {
    path: "agencyLogin",
    name: "agencyLogin",
    // component: agencyLogin

    component: (resolve) => require(["@views/agency/login"], resolve),
  },
  {
    path: "recordList",
    name: "recordList",
    // component: recordList

    component: (resolve) => require(["@views/agency/recordList"], resolve),
  },
  {
    path: "myRecordList",
    name: "myRecordList",
    // component: myRecordList

    component: (resolve) => require(["@views/agency/myRecordList"], resolve),
  },
  {
    path: "projectRecordForm",
    name: "projectRecordForm",
    // component: projectRecordForm,

    component: (resolve) =>
      require(["@views/agency/projectRecordForm"], resolve),
    meta: {
      title: "工程备案申请表",
      requireAuth: false,
    },
  },
  {
    path: "cashDepositForm",
    name: "cashDepositForm",
    // component: cashDepositForm,

    component: (resolve) => require(["@views/agency/cashDepositForm"], resolve),
    meta: {
      title: "退备案保证金",
      requireAuth: false,
    },
  },
  {
    path: "protectionRecordForm",
    name: "protectionRecordForm",
    // component: protectionRecordForm,

    component: (resolve) =>
      require(["@views/agency/protectionRecordForm"], resolve),
    meta: {
      title: "保护区备案登记表",
      requireAuth: false,
    },
  },
  {
    path: "againRecordForm",
    name: "againRecordForm",
    // component: againRecordForm,

    component: (resolve) => require(["@views/agency/againRecordForm"], resolve),
    meta: {
      title: "工程备案续备案",
      requireAuth: false,
    },
  },
  {
    path: "newComPage",
    name: "newComPage",
    // component: newComPage,

    component: (resolve) => require(["@views/agency/newComPage"], resolve),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "newComContent",
    name: "newComContent",
    // component: newComContent,

    component: (resolve) => require(["@views/agency/newComContent"], resolve),
  },
  {
    path: "legalPersonAuth",
    name: "legalPersonAuth",
    // component: newComContent,

    component: (resolve) => require(["@views/agency/legalPersonAuth"], resolve),
  },
  {
    path: "legalPersonAuthForm",
    name: "legalPersonAuthForm",
    // component: newComContent,

    component: (resolve) =>
      require(["@views/agency/legalPersonAuthForm"], resolve),
  },
  {
    path: "myJob",
    name: "myJob",
    component: (resolve) => require(["@views/agency/myJob"], resolve),
  },
  {
    path: "specialStore",
    name: "specialStore",
    component: (resolve) => require(["@views/agency/specialStore"], resolve),
  },
  {
    path: "specialStoreAdd",
    name: "specialStoreAdd",
    component: (resolve) => require(["@views/agency/specialStoreAdd"], resolve),
  },
  {
    path: "publicSigns",
    name: "publicSigns",
    component: (resolve) => require(["@views/agency/publicSigns"], resolve),
  },
  {
    path: "specialStoresSearch",
    name: "specialStoresSearch",
    component: (resolve) =>
      require(["@views/agency/specialStoresSearch"], resolve),
  },
  {
    path: "mainSpecialStore",
    name: "mainSpecialStore",
    component: (resolve) =>
      require(["@views/agency/mainSpecialStore"], resolve),
  },
  {
    path: "mainSpecialStoreAdd",
    name: "mainSpecialStoreAdd",
    component: (resolve) =>
      require(["@views/agency/mainSpecialStoreAdd"], resolve),
  },
  {
    path: "mainPublicSigns",
    name: "mainPublicSigns",
    component: (resolve) => require(["@views/agency/mainPublicSigns"], resolve),
  },
  {
    path: "mainSpecialStoresSearch",
    name: "mainSpecialStoresSearch",
    component: (resolve) =>
      require(["@views/agency/mainSpecialStoresSearch"], resolve),
  },
  {
    path: "dissentList",
    name: "dissentList",

    component: (resolve) => require(["@views/agency/dissentList"], resolve),
  },
  {
    path: "noteList",
    name: "noteList",

    component: (resolve) => require(["@views/agency/noteList"], resolve),
  },
  {
    path: "closeRate",
    name: "closeRate",

    component: (resolve) => require(["@views/agency/closeRate"], resolve),
  },

  {
    path: "specialStoreCheck",
    name: "specialStoreCheck",

    component: (resolve) =>
      require(["@views/agency/specialStoreCheck"], resolve),
  },
  {
    path: "specialStoreImage",
    name: "specialStoreImage",
    component: (resolve) =>
      require(["@views/agency/specialStoreImage"], resolve),
  },

  // 战略采集备案
  {
    path: "projectPurchaseList",
    name: "projectPurchaseList",
    component: (resolve) =>
      require(["@views/agency/projectPurchaseList"], resolve),
  },

  // 战略采集备案-公示区
  {
    path: "projectPurchasePublicityList",
    name: "projectPurchasePublicityList",
    component: (resolve) =>
      require(["@views/agency/projectPurchasePublicityList"], resolve),
  },

  // 战略采集备案表单
  {
    path: "projectPurchaseForm",
    name: "projectPurchaseForm",
    component: (resolve) =>
      require(["@views/agency/projectPurchaseForm"], resolve),
  },

  // 工程备案-公海
  {
    path: "projectOpenList",
    name: "projectOpenList",
    component: (resolve) => require(["@views/agency/projectOpenList"], resolve),
  },

  // 工程备案-公海详情
  {
    path: "projectOpenForm",
    name: "projectOpenForm",
    component: (resolve) => require(["@views/agency/projectOpenForm"], resolve),
  },
];

export default agencyRouter;



// WEBPACK FOOTER //
// ./src/router/agency/index.js